import { useMemo } from 'react';
import { useSettings } from '@backpackjs/storefront';
import { ProductUpsellsList } from '@snippets';

export function Upsells({ selectedVariant }) {
  const settings = useSettings();
  const { heading, products } = settings?.product?.upsells || {};

  const upsellProducts = useMemo(() => {
    const tags = selectedVariant?.product?.tags;
    const newUpsellHandles = tags?.reduce((carry, tag) => {
      if (tag.indexOf('upsell::') > -1) {
        const [, handle, order] = tag.split('::');

        return [
          ...carry,
          {
            product: {
              handle,
              order,
            },
          },
        ].sort((a, b) => {
          return (a?.product?.order || 0) - (b?.product?.order || 0);
        });
      }
      return carry;
    }, []);

    if (newUpsellHandles?.length) {
      return newUpsellHandles;
    }
    return products;
  }, [selectedVariant?.product?.tags]);

  return <ProductUpsellsList heading={heading} products={upsellProducts} />;
}

Upsells.displayName = 'Upsells';
